export default "__VITE_ASSET__I95mXLBO__"